import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seminar-conference',
  templateUrl: './seminar-conference.component.html',
  styleUrls: ['./seminar-conference.component.scss']
})
export class SeminarConferenceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
